import React from "react";
import { PageIntro } from "../components/PageIntro";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";
import { BrandMarquee } from "../components/BrandMarquee";
import { MANIFESTO, VALUES, IMAGES } from "../lib/data";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageIntro
        label="About us"
        titleLines={["Many small farms,", "one in every", "neighbourhood."]}
        subtitle="The freshest, most nutrient-rich food in the world loses most of its value in transit. So we changed the model entirely."
      />

      {/* Manifesto chapters */}
      <section className="px-5 md:px-10 py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto space-y-16 md:space-y-24">
          {MANIFESTO.map((chapter, i) => (
            <Reveal key={chapter.n}>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-black/10 pt-10">
                <div className="md:col-span-3 flex items-baseline gap-4">
                  <span className="font-mono text-sm text-brand-sprout">CH.{chapter.n}</span>
                  <h2 className="font-serif text-2xl md:text-3xl text-brand-ink">{chapter.title}</h2>
                </div>
                <p className="md:col-span-7 md:col-start-5 font-serif text-2xl md:text-3xl lg:text-4xl font-light leading-snug text-brand-ink/90">
                  {chapter.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Soil image band */}
      <section className="px-5 md:px-10">
        <Reveal>
          <div className="max-w-[1400px] mx-auto overflow-hidden rounded-[2rem] h-72 md:h-[28rem]">
            <img src={IMAGES.soil} alt="Hands in soil" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </section>

      <BrandMarquee dark />

      {/* Values */}
      <section className="px-5 md:px-10 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.28em] text-brand-sprout mb-6">
              Our values
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight text-brand-ink max-w-2xl leading-tight">
              What we refuse to compromise on.
            </h2>
          </Reveal>
          <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
            {VALUES.map((v, i) => (
              <StaggerItem key={i}>
                <div className="h-full bg-brand-card rounded-[1.5rem] p-8 md:p-10 border border-black/5">
                  <span className="font-mono text-sm text-brand-sprout">0{i + 1}</span>
                  <h3 className="mt-4 font-serif text-2xl md:text-3xl text-brand-ink">{v.title}</h3>
                  <p className="mt-3 text-brand-muted leading-relaxed">{v.body}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </section>

      {/* Leadership */}
      <section className="px-5 md:px-10 pb-24 md:pb-32">
        <div className="max-w-[1400px] mx-auto">
          <Reveal>
            <div className="rounded-[2rem] bg-brand-dark text-brand-bg p-8 md:p-16 relative overflow-hidden">
              <div className="noise-overlay" />
              <div className="relative">
                <p className="font-mono text-xs uppercase tracking-[0.28em] text-brand-sprout mb-8">
                  Leadership
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="font-serif text-3xl md:text-4xl">Shaikha</h3>
                    <p className="mt-2 text-brand-sprout font-mono text-sm">Founder & Director</p>
                  </div>
                  <div>
                    <h3 className="font-serif text-3xl md:text-4xl">Harikrishnan Kalarikkal Joshi</h3>
                    <p className="mt-2 text-brand-sprout font-mono text-sm">Co-founder, COO & CTO</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
